import React, { useState, useEffect } from "react";
import { Redirect, Link } from "react-router-dom";
import serviceProvider from '../../services/axios'
import { ReferColleaguePopupView } from "./ReferColleaguePopupView";

export const ReferColleaguePopupCtrl=(props)=>{

       const [results, setResults] = useState([]);
       const user = JSON.parse(localStorage.getItem("userData"));
       const usid = user ? user.uid : 0;
    

       useEffect(() => {
              const search = async () => {
                  const apiUrl = `/user?param=inviteddata&uid=${usid}`;
                  const { data } = await serviceProvider.get(apiUrl,true,{});
                  setResults(data);
              };
              search();
          }, []);

          if (results?.resistered_list) {
                            return(
                                          <>
                                                 <ReferColleaguePopupView resistered_list={results.resistered_list} invited_list={results.invited_list}  {...props} />
                                          </>
                            )
              }{
                          return (
                                          <>
                                                 <div></div>
                                          </>
                            );
              }
          

}